export default __webpack_public_path__ + "static/media/shivada_jade_sliver.e542905c.png";